import { render, staticRenderFns } from "./EditCertificateModal.vue?vue&type=template&id=3eca9bf8"
import script from "./EditCertificateModal.vue?vue&type=script&lang=js"
export * from "./EditCertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports